
const digest = 'b5f3696c3e9d2170e711a225690e83e70dcd8b87be53fdf5b08439d6e71ccb04';
const classes = {"wrapper":"_wrapper_1h9tt_1","details":"_details_1h9tt_10","title":"_title_1h9tt_17","description":"_description_1h9tt_25","toggler":"_toggler_1h9tt_32","toggleText":"_toggleText_1h9tt_40"};
const css = `._wrapper_1h9tt_1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px 8px 19px;
  border-left: 5px solid #2463c1;
  cursor: pointer;
}

._details_1h9tt_10 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

._title_1h9tt_17 {
  font-family: Rubik;
  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
  margin-bottom: 5px;
}

._description_1h9tt_25 {
  font-family: Rubik;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
}

._toggler_1h9tt_32 {
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 7px;
  align-items: center;
  color: #2463c1;
}

._toggleText_1h9tt_40 {
  font-size: 14px;
  line-height: 17px;
  text-decoration: underline;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  